var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'has-background-black-ter': this.$root.$children[0].darkTheme},attrs:{"id":"app"}},[_c('Background'),_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }